export default class AgentSearchResponse {
    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.dateCreated = jsonResponse["dateCreated"];
        this.manager = jsonResponse["manager"];
        this.firstName = jsonResponse["firstName"];
        this.lastName = jsonResponse["lastName"];
        this.agentCode = jsonResponse["agentCode"];
        this.agentType = jsonResponse["agentType"];
        this.agentStatus = jsonResponse["agentStatus"];
    }

}
